module.exports = __webpack_public_path__ + "img/744.61b96797.jpg";